/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const OptionalMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of an OptionalMessage.
     * @exports IOptionalMessage
     * @interface IOptionalMessage
     * @property {Uint8Array|null} [valueIfPresent] OptionalMessage valueIfPresent
     */

    /**
     * Constructs a new OptionalMessage.
     * @exports OptionalMessage
     * @classdesc Represents an OptionalMessage.
     * @implements IOptionalMessage
     * @constructor
     * @param {IOptionalMessage=} [properties] Properties to set
     */
    function OptionalMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OptionalMessage valueIfPresent.
     * @member {Uint8Array} valueIfPresent
     * @memberof OptionalMessage
     * @instance
     */
    OptionalMessage.prototype.valueIfPresent = $util.newBuffer([]);

    /**
     * Creates a new OptionalMessage instance using the specified properties.
     * @function create
     * @memberof OptionalMessage
     * @static
     * @param {IOptionalMessage=} [properties] Properties to set
     * @returns {OptionalMessage} OptionalMessage instance
     */
    OptionalMessage.create = function create(properties) {
        return new OptionalMessage(properties);
    };

    /**
     * Encodes the specified OptionalMessage message. Does not implicitly {@link OptionalMessage.verify|verify} messages.
     * @function encode
     * @memberof OptionalMessage
     * @static
     * @param {IOptionalMessage} message OptionalMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OptionalMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.valueIfPresent != null && Object.hasOwnProperty.call(message, "valueIfPresent"))
            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.valueIfPresent);
        return writer;
    };

    /**
     * Encodes the specified OptionalMessage message, length delimited. Does not implicitly {@link OptionalMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OptionalMessage
     * @static
     * @param {IOptionalMessage} message OptionalMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OptionalMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OptionalMessage message from the specified reader or buffer.
     * @function decode
     * @memberof OptionalMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OptionalMessage} OptionalMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OptionalMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new OptionalMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.valueIfPresent = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OptionalMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OptionalMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OptionalMessage} OptionalMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OptionalMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OptionalMessage message.
     * @function verify
     * @memberof OptionalMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OptionalMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.valueIfPresent != null && message.hasOwnProperty("valueIfPresent"))
            if (!(message.valueIfPresent && typeof message.valueIfPresent.length === "number" || $util.isString(message.valueIfPresent)))
                return "valueIfPresent: buffer expected";
        return null;
    };

    /**
     * Creates an OptionalMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OptionalMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OptionalMessage} OptionalMessage
     */
    OptionalMessage.fromObject = function fromObject(object) {
        if (object instanceof OptionalMessage)
            return object;
        let message = new OptionalMessage();
        if (object.valueIfPresent != null)
            if (typeof object.valueIfPresent === "string")
                $util.base64.decode(object.valueIfPresent, message.valueIfPresent = $util.newBuffer($util.base64.length(object.valueIfPresent)), 0);
            else if (object.valueIfPresent.length)
                message.valueIfPresent = object.valueIfPresent;
        return message;
    };

    /**
     * Creates a plain object from an OptionalMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OptionalMessage
     * @static
     * @param {OptionalMessage} message OptionalMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OptionalMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            if (options.bytes === String)
                object.valueIfPresent = "";
            else {
                object.valueIfPresent = [];
                if (options.bytes !== Array)
                    object.valueIfPresent = $util.newBuffer(object.valueIfPresent);
            }
        if (message.valueIfPresent != null && message.hasOwnProperty("valueIfPresent"))
            object.valueIfPresent = options.bytes === String ? $util.base64.encode(message.valueIfPresent, 0, message.valueIfPresent.length) : options.bytes === Array ? Array.prototype.slice.call(message.valueIfPresent) : message.valueIfPresent;
        return object;
    };

    /**
     * Converts this OptionalMessage to JSON.
     * @function toJSON
     * @memberof OptionalMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OptionalMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OptionalMessage;
})();

export const ArrayMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of an ArrayMessage.
     * @exports IArrayMessage
     * @interface IArrayMessage
     * @property {Array.<Uint8Array>|null} [elements] ArrayMessage elements
     */

    /**
     * Constructs a new ArrayMessage.
     * @exports ArrayMessage
     * @classdesc Represents an ArrayMessage.
     * @implements IArrayMessage
     * @constructor
     * @param {IArrayMessage=} [properties] Properties to set
     */
    function ArrayMessage(properties) {
        this.elements = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ArrayMessage elements.
     * @member {Array.<Uint8Array>} elements
     * @memberof ArrayMessage
     * @instance
     */
    ArrayMessage.prototype.elements = $util.emptyArray;

    /**
     * Creates a new ArrayMessage instance using the specified properties.
     * @function create
     * @memberof ArrayMessage
     * @static
     * @param {IArrayMessage=} [properties] Properties to set
     * @returns {ArrayMessage} ArrayMessage instance
     */
    ArrayMessage.create = function create(properties) {
        return new ArrayMessage(properties);
    };

    /**
     * Encodes the specified ArrayMessage message. Does not implicitly {@link ArrayMessage.verify|verify} messages.
     * @function encode
     * @memberof ArrayMessage
     * @static
     * @param {IArrayMessage} message ArrayMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ArrayMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.elements != null && message.elements.length)
            for (let i = 0; i < message.elements.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.elements[i]);
        return writer;
    };

    /**
     * Encodes the specified ArrayMessage message, length delimited. Does not implicitly {@link ArrayMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ArrayMessage
     * @static
     * @param {IArrayMessage} message ArrayMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ArrayMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ArrayMessage message from the specified reader or buffer.
     * @function decode
     * @memberof ArrayMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ArrayMessage} ArrayMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ArrayMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new ArrayMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.elements && message.elements.length))
                    message.elements = [];
                message.elements.push(reader.bytes());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ArrayMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ArrayMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ArrayMessage} ArrayMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ArrayMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ArrayMessage message.
     * @function verify
     * @memberof ArrayMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ArrayMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.elements != null && message.hasOwnProperty("elements")) {
            if (!Array.isArray(message.elements))
                return "elements: array expected";
            for (let i = 0; i < message.elements.length; ++i)
                if (!(message.elements[i] && typeof message.elements[i].length === "number" || $util.isString(message.elements[i])))
                    return "elements: buffer[] expected";
        }
        return null;
    };

    /**
     * Creates an ArrayMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ArrayMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ArrayMessage} ArrayMessage
     */
    ArrayMessage.fromObject = function fromObject(object) {
        if (object instanceof ArrayMessage)
            return object;
        let message = new ArrayMessage();
        if (object.elements) {
            if (!Array.isArray(object.elements))
                throw TypeError(".ArrayMessage.elements: array expected");
            message.elements = [];
            for (let i = 0; i < object.elements.length; ++i)
                if (typeof object.elements[i] === "string")
                    $util.base64.decode(object.elements[i], message.elements[i] = $util.newBuffer($util.base64.length(object.elements[i])), 0);
                else if (object.elements[i].length)
                    message.elements[i] = object.elements[i];
        }
        return message;
    };

    /**
     * Creates a plain object from an ArrayMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ArrayMessage
     * @static
     * @param {ArrayMessage} message ArrayMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ArrayMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.elements = [];
        if (message.elements && message.elements.length) {
            object.elements = [];
            for (let j = 0; j < message.elements.length; ++j)
                object.elements[j] = options.bytes === String ? $util.base64.encode(message.elements[j], 0, message.elements[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.elements[j]) : message.elements[j];
        }
        return object;
    };

    /**
     * Converts this ArrayMessage to JSON.
     * @function toJSON
     * @memberof ArrayMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ArrayMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ArrayMessage;
})();

export const ObjectMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of an ObjectMessage.
     * @exports IObjectMessage
     * @interface IObjectMessage
     * @property {Object.<string,Uint8Array>|null} [properties] ObjectMessage properties
     */

    /**
     * Constructs a new ObjectMessage.
     * @exports ObjectMessage
     * @classdesc Represents an ObjectMessage.
     * @implements IObjectMessage
     * @constructor
     * @param {IObjectMessage=} [properties] Properties to set
     */
    function ObjectMessage(properties) {
        this.properties = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ObjectMessage properties.
     * @member {Object.<string,Uint8Array>} properties
     * @memberof ObjectMessage
     * @instance
     */
    ObjectMessage.prototype.properties = $util.emptyObject;

    /**
     * Creates a new ObjectMessage instance using the specified properties.
     * @function create
     * @memberof ObjectMessage
     * @static
     * @param {IObjectMessage=} [properties] Properties to set
     * @returns {ObjectMessage} ObjectMessage instance
     */
    ObjectMessage.create = function create(properties) {
        return new ObjectMessage(properties);
    };

    /**
     * Encodes the specified ObjectMessage message. Does not implicitly {@link ObjectMessage.verify|verify} messages.
     * @function encode
     * @memberof ObjectMessage
     * @static
     * @param {IObjectMessage} message ObjectMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ObjectMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.properties != null && Object.hasOwnProperty.call(message, "properties"))
            for (let keys = Object.keys(message.properties), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).bytes(message.properties[keys[i]]).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ObjectMessage message, length delimited. Does not implicitly {@link ObjectMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ObjectMessage
     * @static
     * @param {IObjectMessage} message ObjectMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ObjectMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ObjectMessage message from the specified reader or buffer.
     * @function decode
     * @memberof ObjectMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ObjectMessage} ObjectMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ObjectMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new ObjectMessage(), key;
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                reader.skip().pos++;
                if (message.properties === $util.emptyObject)
                    message.properties = {};
                key = reader.string();
                reader.pos++;
                message.properties[key] = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ObjectMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ObjectMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ObjectMessage} ObjectMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ObjectMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ObjectMessage message.
     * @function verify
     * @memberof ObjectMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ObjectMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.properties != null && message.hasOwnProperty("properties")) {
            if (!$util.isObject(message.properties))
                return "properties: object expected";
            let key = Object.keys(message.properties);
            for (let i = 0; i < key.length; ++i)
                if (!(message.properties[key[i]] && typeof message.properties[key[i]].length === "number" || $util.isString(message.properties[key[i]])))
                    return "properties: buffer{k:string} expected";
        }
        return null;
    };

    /**
     * Creates an ObjectMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ObjectMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ObjectMessage} ObjectMessage
     */
    ObjectMessage.fromObject = function fromObject(object) {
        if (object instanceof ObjectMessage)
            return object;
        let message = new ObjectMessage();
        if (object.properties) {
            if (typeof object.properties !== "object")
                throw TypeError(".ObjectMessage.properties: object expected");
            message.properties = {};
            for (let keys = Object.keys(object.properties), i = 0; i < keys.length; ++i)
                if (typeof object.properties[keys[i]] === "string")
                    $util.base64.decode(object.properties[keys[i]], message.properties[keys[i]] = $util.newBuffer($util.base64.length(object.properties[keys[i]])), 0);
                else if (object.properties[keys[i]].length)
                    message.properties[keys[i]] = object.properties[keys[i]];
        }
        return message;
    };

    /**
     * Creates a plain object from an ObjectMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ObjectMessage
     * @static
     * @param {ObjectMessage} message ObjectMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ObjectMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults)
            object.properties = {};
        let keys2;
        if (message.properties && (keys2 = Object.keys(message.properties)).length) {
            object.properties = {};
            for (let j = 0; j < keys2.length; ++j)
                object.properties[keys2[j]] = options.bytes === String ? $util.base64.encode(message.properties[keys2[j]], 0, message.properties[keys2[j]].length) : options.bytes === Array ? Array.prototype.slice.call(message.properties[keys2[j]]) : message.properties[keys2[j]];
        }
        return object;
    };

    /**
     * Converts this ObjectMessage to JSON.
     * @function toJSON
     * @memberof ObjectMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ObjectMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ObjectMessage;
})();

export const DefaultSerializerMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a DefaultSerializerMessage.
     * @exports IDefaultSerializerMessage
     * @interface IDefaultSerializerMessage
     * @property {string|null} [stringValue] DefaultSerializerMessage stringValue
     * @property {number|Long|null} [intValue] DefaultSerializerMessage intValue
     * @property {number|null} [doubleValue] DefaultSerializerMessage doubleValue
     * @property {boolean|null} [booleanValue] DefaultSerializerMessage booleanValue
     * @property {boolean|null} [undefinedValue] DefaultSerializerMessage undefinedValue
     * @property {boolean|null} [nullValue] DefaultSerializerMessage nullValue
     * @property {IArrayMessage|null} [arrayValue] DefaultSerializerMessage arrayValue
     * @property {IObjectMessage|null} [objectValue] DefaultSerializerMessage objectValue
     * @property {Uint8Array|null} [bytesValue] DefaultSerializerMessage bytesValue
     * @property {IOptionalMessage|null} [optionalValue] DefaultSerializerMessage optionalValue
     */

    /**
     * Constructs a new DefaultSerializerMessage.
     * @exports DefaultSerializerMessage
     * @classdesc Represents a DefaultSerializerMessage.
     * @implements IDefaultSerializerMessage
     * @constructor
     * @param {IDefaultSerializerMessage=} [properties] Properties to set
     */
    function DefaultSerializerMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DefaultSerializerMessage stringValue.
     * @member {string} stringValue
     * @memberof DefaultSerializerMessage
     * @instance
     */
    DefaultSerializerMessage.prototype.stringValue = "";

    /**
     * DefaultSerializerMessage intValue.
     * @member {number|Long} intValue
     * @memberof DefaultSerializerMessage
     * @instance
     */
    DefaultSerializerMessage.prototype.intValue = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * DefaultSerializerMessage doubleValue.
     * @member {number} doubleValue
     * @memberof DefaultSerializerMessage
     * @instance
     */
    DefaultSerializerMessage.prototype.doubleValue = 0;

    /**
     * DefaultSerializerMessage booleanValue.
     * @member {boolean} booleanValue
     * @memberof DefaultSerializerMessage
     * @instance
     */
    DefaultSerializerMessage.prototype.booleanValue = false;

    /**
     * DefaultSerializerMessage undefinedValue.
     * @member {boolean} undefinedValue
     * @memberof DefaultSerializerMessage
     * @instance
     */
    DefaultSerializerMessage.prototype.undefinedValue = false;

    /**
     * DefaultSerializerMessage nullValue.
     * @member {boolean} nullValue
     * @memberof DefaultSerializerMessage
     * @instance
     */
    DefaultSerializerMessage.prototype.nullValue = false;

    /**
     * DefaultSerializerMessage arrayValue.
     * @member {IArrayMessage|null|undefined} arrayValue
     * @memberof DefaultSerializerMessage
     * @instance
     */
    DefaultSerializerMessage.prototype.arrayValue = null;

    /**
     * DefaultSerializerMessage objectValue.
     * @member {IObjectMessage|null|undefined} objectValue
     * @memberof DefaultSerializerMessage
     * @instance
     */
    DefaultSerializerMessage.prototype.objectValue = null;

    /**
     * DefaultSerializerMessage bytesValue.
     * @member {Uint8Array} bytesValue
     * @memberof DefaultSerializerMessage
     * @instance
     */
    DefaultSerializerMessage.prototype.bytesValue = $util.newBuffer([]);

    /**
     * DefaultSerializerMessage optionalValue.
     * @member {IOptionalMessage|null|undefined} optionalValue
     * @memberof DefaultSerializerMessage
     * @instance
     */
    DefaultSerializerMessage.prototype.optionalValue = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * DefaultSerializerMessage value.
     * @member {"stringValue"|"intValue"|"doubleValue"|"booleanValue"|"undefinedValue"|"nullValue"|"arrayValue"|"objectValue"|"bytesValue"|"optionalValue"|undefined} value
     * @memberof DefaultSerializerMessage
     * @instance
     */
    Object.defineProperty(DefaultSerializerMessage.prototype, "value", {
        get: $util.oneOfGetter($oneOfFields = ["stringValue", "intValue", "doubleValue", "booleanValue", "undefinedValue", "nullValue", "arrayValue", "objectValue", "bytesValue", "optionalValue"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new DefaultSerializerMessage instance using the specified properties.
     * @function create
     * @memberof DefaultSerializerMessage
     * @static
     * @param {IDefaultSerializerMessage=} [properties] Properties to set
     * @returns {DefaultSerializerMessage} DefaultSerializerMessage instance
     */
    DefaultSerializerMessage.create = function create(properties) {
        return new DefaultSerializerMessage(properties);
    };

    /**
     * Encodes the specified DefaultSerializerMessage message. Does not implicitly {@link DefaultSerializerMessage.verify|verify} messages.
     * @function encode
     * @memberof DefaultSerializerMessage
     * @static
     * @param {IDefaultSerializerMessage} message DefaultSerializerMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DefaultSerializerMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.stringValue != null && Object.hasOwnProperty.call(message, "stringValue"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.stringValue);
        if (message.intValue != null && Object.hasOwnProperty.call(message, "intValue"))
            writer.uint32(/* id 2, wireType 0 =*/16).sint64(message.intValue);
        if (message.doubleValue != null && Object.hasOwnProperty.call(message, "doubleValue"))
            writer.uint32(/* id 3, wireType 1 =*/25).double(message.doubleValue);
        if (message.booleanValue != null && Object.hasOwnProperty.call(message, "booleanValue"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.booleanValue);
        if (message.undefinedValue != null && Object.hasOwnProperty.call(message, "undefinedValue"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.undefinedValue);
        if (message.nullValue != null && Object.hasOwnProperty.call(message, "nullValue"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.nullValue);
        if (message.arrayValue != null && Object.hasOwnProperty.call(message, "arrayValue"))
            ArrayMessage.encode(message.arrayValue, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.objectValue != null && Object.hasOwnProperty.call(message, "objectValue"))
            ObjectMessage.encode(message.objectValue, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.bytesValue != null && Object.hasOwnProperty.call(message, "bytesValue"))
            writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.bytesValue);
        if (message.optionalValue != null && Object.hasOwnProperty.call(message, "optionalValue"))
            OptionalMessage.encode(message.optionalValue, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DefaultSerializerMessage message, length delimited. Does not implicitly {@link DefaultSerializerMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DefaultSerializerMessage
     * @static
     * @param {IDefaultSerializerMessage} message DefaultSerializerMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DefaultSerializerMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DefaultSerializerMessage message from the specified reader or buffer.
     * @function decode
     * @memberof DefaultSerializerMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DefaultSerializerMessage} DefaultSerializerMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DefaultSerializerMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new DefaultSerializerMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.stringValue = reader.string();
                break;
            case 2:
                message.intValue = reader.sint64();
                break;
            case 3:
                message.doubleValue = reader.double();
                break;
            case 4:
                message.booleanValue = reader.bool();
                break;
            case 5:
                message.undefinedValue = reader.bool();
                break;
            case 6:
                message.nullValue = reader.bool();
                break;
            case 7:
                message.arrayValue = ArrayMessage.decode(reader, reader.uint32());
                break;
            case 8:
                message.objectValue = ObjectMessage.decode(reader, reader.uint32());
                break;
            case 9:
                message.bytesValue = reader.bytes();
                break;
            case 10:
                message.optionalValue = OptionalMessage.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DefaultSerializerMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DefaultSerializerMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DefaultSerializerMessage} DefaultSerializerMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DefaultSerializerMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DefaultSerializerMessage message.
     * @function verify
     * @memberof DefaultSerializerMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DefaultSerializerMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        let properties = {};
        if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
            properties.value = 1;
            if (!$util.isString(message.stringValue))
                return "stringValue: string expected";
        }
        if (message.intValue != null && message.hasOwnProperty("intValue")) {
            if (properties.value === 1)
                return "value: multiple values";
            properties.value = 1;
            if (!$util.isInteger(message.intValue) && !(message.intValue && $util.isInteger(message.intValue.low) && $util.isInteger(message.intValue.high)))
                return "intValue: integer|Long expected";
        }
        if (message.doubleValue != null && message.hasOwnProperty("doubleValue")) {
            if (properties.value === 1)
                return "value: multiple values";
            properties.value = 1;
            if (typeof message.doubleValue !== "number")
                return "doubleValue: number expected";
        }
        if (message.booleanValue != null && message.hasOwnProperty("booleanValue")) {
            if (properties.value === 1)
                return "value: multiple values";
            properties.value = 1;
            if (typeof message.booleanValue !== "boolean")
                return "booleanValue: boolean expected";
        }
        if (message.undefinedValue != null && message.hasOwnProperty("undefinedValue")) {
            if (properties.value === 1)
                return "value: multiple values";
            properties.value = 1;
            if (typeof message.undefinedValue !== "boolean")
                return "undefinedValue: boolean expected";
        }
        if (message.nullValue != null && message.hasOwnProperty("nullValue")) {
            if (properties.value === 1)
                return "value: multiple values";
            properties.value = 1;
            if (typeof message.nullValue !== "boolean")
                return "nullValue: boolean expected";
        }
        if (message.arrayValue != null && message.hasOwnProperty("arrayValue")) {
            if (properties.value === 1)
                return "value: multiple values";
            properties.value = 1;
            {
                let error = ArrayMessage.verify(message.arrayValue);
                if (error)
                    return "arrayValue." + error;
            }
        }
        if (message.objectValue != null && message.hasOwnProperty("objectValue")) {
            if (properties.value === 1)
                return "value: multiple values";
            properties.value = 1;
            {
                let error = ObjectMessage.verify(message.objectValue);
                if (error)
                    return "objectValue." + error;
            }
        }
        if (message.bytesValue != null && message.hasOwnProperty("bytesValue")) {
            if (properties.value === 1)
                return "value: multiple values";
            properties.value = 1;
            if (!(message.bytesValue && typeof message.bytesValue.length === "number" || $util.isString(message.bytesValue)))
                return "bytesValue: buffer expected";
        }
        if (message.optionalValue != null && message.hasOwnProperty("optionalValue")) {
            if (properties.value === 1)
                return "value: multiple values";
            properties.value = 1;
            {
                let error = OptionalMessage.verify(message.optionalValue);
                if (error)
                    return "optionalValue." + error;
            }
        }
        return null;
    };

    /**
     * Creates a DefaultSerializerMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DefaultSerializerMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DefaultSerializerMessage} DefaultSerializerMessage
     */
    DefaultSerializerMessage.fromObject = function fromObject(object) {
        if (object instanceof DefaultSerializerMessage)
            return object;
        let message = new DefaultSerializerMessage();
        if (object.stringValue != null)
            message.stringValue = String(object.stringValue);
        if (object.intValue != null)
            if ($util.Long)
                (message.intValue = $util.Long.fromValue(object.intValue)).unsigned = false;
            else if (typeof object.intValue === "string")
                message.intValue = parseInt(object.intValue, 10);
            else if (typeof object.intValue === "number")
                message.intValue = object.intValue;
            else if (typeof object.intValue === "object")
                message.intValue = new $util.LongBits(object.intValue.low >>> 0, object.intValue.high >>> 0).toNumber();
        if (object.doubleValue != null)
            message.doubleValue = Number(object.doubleValue);
        if (object.booleanValue != null)
            message.booleanValue = Boolean(object.booleanValue);
        if (object.undefinedValue != null)
            message.undefinedValue = Boolean(object.undefinedValue);
        if (object.nullValue != null)
            message.nullValue = Boolean(object.nullValue);
        if (object.arrayValue != null) {
            if (typeof object.arrayValue !== "object")
                throw TypeError(".DefaultSerializerMessage.arrayValue: object expected");
            message.arrayValue = ArrayMessage.fromObject(object.arrayValue);
        }
        if (object.objectValue != null) {
            if (typeof object.objectValue !== "object")
                throw TypeError(".DefaultSerializerMessage.objectValue: object expected");
            message.objectValue = ObjectMessage.fromObject(object.objectValue);
        }
        if (object.bytesValue != null)
            if (typeof object.bytesValue === "string")
                $util.base64.decode(object.bytesValue, message.bytesValue = $util.newBuffer($util.base64.length(object.bytesValue)), 0);
            else if (object.bytesValue.length)
                message.bytesValue = object.bytesValue;
        if (object.optionalValue != null) {
            if (typeof object.optionalValue !== "object")
                throw TypeError(".DefaultSerializerMessage.optionalValue: object expected");
            message.optionalValue = OptionalMessage.fromObject(object.optionalValue);
        }
        return message;
    };

    /**
     * Creates a plain object from a DefaultSerializerMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DefaultSerializerMessage
     * @static
     * @param {DefaultSerializerMessage} message DefaultSerializerMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DefaultSerializerMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.stringValue != null && message.hasOwnProperty("stringValue")) {
            object.stringValue = message.stringValue;
            if (options.oneofs)
                object.value = "stringValue";
        }
        if (message.intValue != null && message.hasOwnProperty("intValue")) {
            if (typeof message.intValue === "number")
                object.intValue = options.longs === String ? String(message.intValue) : message.intValue;
            else
                object.intValue = options.longs === String ? $util.Long.prototype.toString.call(message.intValue) : options.longs === Number ? new $util.LongBits(message.intValue.low >>> 0, message.intValue.high >>> 0).toNumber() : message.intValue;
            if (options.oneofs)
                object.value = "intValue";
        }
        if (message.doubleValue != null && message.hasOwnProperty("doubleValue")) {
            object.doubleValue = options.json && !isFinite(message.doubleValue) ? String(message.doubleValue) : message.doubleValue;
            if (options.oneofs)
                object.value = "doubleValue";
        }
        if (message.booleanValue != null && message.hasOwnProperty("booleanValue")) {
            object.booleanValue = message.booleanValue;
            if (options.oneofs)
                object.value = "booleanValue";
        }
        if (message.undefinedValue != null && message.hasOwnProperty("undefinedValue")) {
            object.undefinedValue = message.undefinedValue;
            if (options.oneofs)
                object.value = "undefinedValue";
        }
        if (message.nullValue != null && message.hasOwnProperty("nullValue")) {
            object.nullValue = message.nullValue;
            if (options.oneofs)
                object.value = "nullValue";
        }
        if (message.arrayValue != null && message.hasOwnProperty("arrayValue")) {
            object.arrayValue = ArrayMessage.toObject(message.arrayValue, options);
            if (options.oneofs)
                object.value = "arrayValue";
        }
        if (message.objectValue != null && message.hasOwnProperty("objectValue")) {
            object.objectValue = ObjectMessage.toObject(message.objectValue, options);
            if (options.oneofs)
                object.value = "objectValue";
        }
        if (message.bytesValue != null && message.hasOwnProperty("bytesValue")) {
            object.bytesValue = options.bytes === String ? $util.base64.encode(message.bytesValue, 0, message.bytesValue.length) : options.bytes === Array ? Array.prototype.slice.call(message.bytesValue) : message.bytesValue;
            if (options.oneofs)
                object.value = "bytesValue";
        }
        if (message.optionalValue != null && message.hasOwnProperty("optionalValue")) {
            object.optionalValue = OptionalMessage.toObject(message.optionalValue, options);
            if (options.oneofs)
                object.value = "optionalValue";
        }
        return object;
    };

    /**
     * Converts this DefaultSerializerMessage to JSON.
     * @function toJSON
     * @memberof DefaultSerializerMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DefaultSerializerMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DefaultSerializerMessage;
})();

export const PairSerializerMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a PairSerializerMessage.
     * @exports IPairSerializerMessage
     * @interface IPairSerializerMessage
     * @property {Uint8Array} one PairSerializerMessage one
     * @property {Uint8Array} two PairSerializerMessage two
     */

    /**
     * Constructs a new PairSerializerMessage.
     * @exports PairSerializerMessage
     * @classdesc Represents a PairSerializerMessage.
     * @implements IPairSerializerMessage
     * @constructor
     * @param {IPairSerializerMessage=} [properties] Properties to set
     */
    function PairSerializerMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PairSerializerMessage one.
     * @member {Uint8Array} one
     * @memberof PairSerializerMessage
     * @instance
     */
    PairSerializerMessage.prototype.one = $util.newBuffer([]);

    /**
     * PairSerializerMessage two.
     * @member {Uint8Array} two
     * @memberof PairSerializerMessage
     * @instance
     */
    PairSerializerMessage.prototype.two = $util.newBuffer([]);

    /**
     * Creates a new PairSerializerMessage instance using the specified properties.
     * @function create
     * @memberof PairSerializerMessage
     * @static
     * @param {IPairSerializerMessage=} [properties] Properties to set
     * @returns {PairSerializerMessage} PairSerializerMessage instance
     */
    PairSerializerMessage.create = function create(properties) {
        return new PairSerializerMessage(properties);
    };

    /**
     * Encodes the specified PairSerializerMessage message. Does not implicitly {@link PairSerializerMessage.verify|verify} messages.
     * @function encode
     * @memberof PairSerializerMessage
     * @static
     * @param {IPairSerializerMessage} message PairSerializerMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PairSerializerMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.one);
        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.two);
        return writer;
    };

    /**
     * Encodes the specified PairSerializerMessage message, length delimited. Does not implicitly {@link PairSerializerMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PairSerializerMessage
     * @static
     * @param {IPairSerializerMessage} message PairSerializerMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PairSerializerMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PairSerializerMessage message from the specified reader or buffer.
     * @function decode
     * @memberof PairSerializerMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PairSerializerMessage} PairSerializerMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PairSerializerMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new PairSerializerMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.one = reader.bytes();
                break;
            case 2:
                message.two = reader.bytes();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("one"))
            throw $util.ProtocolError("missing required 'one'", { instance: message });
        if (!message.hasOwnProperty("two"))
            throw $util.ProtocolError("missing required 'two'", { instance: message });
        return message;
    };

    /**
     * Decodes a PairSerializerMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PairSerializerMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PairSerializerMessage} PairSerializerMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PairSerializerMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PairSerializerMessage message.
     * @function verify
     * @memberof PairSerializerMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PairSerializerMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.one && typeof message.one.length === "number" || $util.isString(message.one)))
            return "one: buffer expected";
        if (!(message.two && typeof message.two.length === "number" || $util.isString(message.two)))
            return "two: buffer expected";
        return null;
    };

    /**
     * Creates a PairSerializerMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PairSerializerMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PairSerializerMessage} PairSerializerMessage
     */
    PairSerializerMessage.fromObject = function fromObject(object) {
        if (object instanceof PairSerializerMessage)
            return object;
        let message = new PairSerializerMessage();
        if (object.one != null)
            if (typeof object.one === "string")
                $util.base64.decode(object.one, message.one = $util.newBuffer($util.base64.length(object.one)), 0);
            else if (object.one.length)
                message.one = object.one;
        if (object.two != null)
            if (typeof object.two === "string")
                $util.base64.decode(object.two, message.two = $util.newBuffer($util.base64.length(object.two)), 0);
            else if (object.two.length)
                message.two = object.two;
        return message;
    };

    /**
     * Creates a plain object from a PairSerializerMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PairSerializerMessage
     * @static
     * @param {PairSerializerMessage} message PairSerializerMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PairSerializerMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.one = "";
            else {
                object.one = [];
                if (options.bytes !== Array)
                    object.one = $util.newBuffer(object.one);
            }
            if (options.bytes === String)
                object.two = "";
            else {
                object.two = [];
                if (options.bytes !== Array)
                    object.two = $util.newBuffer(object.two);
            }
        }
        if (message.one != null && message.hasOwnProperty("one"))
            object.one = options.bytes === String ? $util.base64.encode(message.one, 0, message.one.length) : options.bytes === Array ? Array.prototype.slice.call(message.one) : message.one;
        if (message.two != null && message.hasOwnProperty("two"))
            object.two = options.bytes === String ? $util.base64.encode(message.two, 0, message.two.length) : options.bytes === Array ? Array.prototype.slice.call(message.two) : message.two;
        return object;
    };

    /**
     * Converts this PairSerializerMessage to JSON.
     * @function toJSON
     * @memberof PairSerializerMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PairSerializerMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PairSerializerMessage;
})();

export const CollabIDMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a CollabIDMessage.
     * @exports ICollabIDMessage
     * @interface ICollabIDMessage
     * @property {Array.<string>|null} [collabIDPath] CollabIDMessage collabIDPath
     */

    /**
     * Constructs a new CollabIDMessage.
     * @exports CollabIDMessage
     * @classdesc Represents a CollabIDMessage.
     * @implements ICollabIDMessage
     * @constructor
     * @param {ICollabIDMessage=} [properties] Properties to set
     */
    function CollabIDMessage(properties) {
        this.collabIDPath = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CollabIDMessage collabIDPath.
     * @member {Array.<string>} collabIDPath
     * @memberof CollabIDMessage
     * @instance
     */
    CollabIDMessage.prototype.collabIDPath = $util.emptyArray;

    /**
     * Creates a new CollabIDMessage instance using the specified properties.
     * @function create
     * @memberof CollabIDMessage
     * @static
     * @param {ICollabIDMessage=} [properties] Properties to set
     * @returns {CollabIDMessage} CollabIDMessage instance
     */
    CollabIDMessage.create = function create(properties) {
        return new CollabIDMessage(properties);
    };

    /**
     * Encodes the specified CollabIDMessage message. Does not implicitly {@link CollabIDMessage.verify|verify} messages.
     * @function encode
     * @memberof CollabIDMessage
     * @static
     * @param {ICollabIDMessage} message CollabIDMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CollabIDMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.collabIDPath != null && message.collabIDPath.length)
            for (let i = 0; i < message.collabIDPath.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.collabIDPath[i]);
        return writer;
    };

    /**
     * Encodes the specified CollabIDMessage message, length delimited. Does not implicitly {@link CollabIDMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CollabIDMessage
     * @static
     * @param {ICollabIDMessage} message CollabIDMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CollabIDMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CollabIDMessage message from the specified reader or buffer.
     * @function decode
     * @memberof CollabIDMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CollabIDMessage} CollabIDMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CollabIDMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new CollabIDMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.collabIDPath && message.collabIDPath.length))
                    message.collabIDPath = [];
                message.collabIDPath.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CollabIDMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CollabIDMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CollabIDMessage} CollabIDMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CollabIDMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CollabIDMessage message.
     * @function verify
     * @memberof CollabIDMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CollabIDMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.collabIDPath != null && message.hasOwnProperty("collabIDPath")) {
            if (!Array.isArray(message.collabIDPath))
                return "collabIDPath: array expected";
            for (let i = 0; i < message.collabIDPath.length; ++i)
                if (!$util.isString(message.collabIDPath[i]))
                    return "collabIDPath: string[] expected";
        }
        return null;
    };

    /**
     * Creates a CollabIDMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CollabIDMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CollabIDMessage} CollabIDMessage
     */
    CollabIDMessage.fromObject = function fromObject(object) {
        if (object instanceof CollabIDMessage)
            return object;
        let message = new CollabIDMessage();
        if (object.collabIDPath) {
            if (!Array.isArray(object.collabIDPath))
                throw TypeError(".CollabIDMessage.collabIDPath: array expected");
            message.collabIDPath = [];
            for (let i = 0; i < object.collabIDPath.length; ++i)
                message.collabIDPath[i] = String(object.collabIDPath[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a CollabIDMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CollabIDMessage
     * @static
     * @param {CollabIDMessage} message CollabIDMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CollabIDMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.collabIDPath = [];
        if (message.collabIDPath && message.collabIDPath.length) {
            object.collabIDPath = [];
            for (let j = 0; j < message.collabIDPath.length; ++j)
                object.collabIDPath[j] = message.collabIDPath[j];
        }
        return object;
    };

    /**
     * Converts this CollabIDMessage to JSON.
     * @function toJSON
     * @memberof CollabIDMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CollabIDMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CollabIDMessage;
})();

export const MessageStacksMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a MessageStacksMessage.
     * @exports IMessageStacksMessage
     * @interface IMessageStacksMessage
     * @property {Uint8Array} edgeLabelsPacked MessageStacksMessage edgeLabelsPacked
     * @property {Array.<number>|null} [edgeLabelLengths] MessageStacksMessage edgeLabelLengths
     * @property {Array.<number>|null} [edgeParents] MessageStacksMessage edgeParents
     * @property {Array.<number>|null} [messageStackIDs] MessageStacksMessage messageStackIDs
     */

    /**
     * Constructs a new MessageStacksMessage.
     * @exports MessageStacksMessage
     * @classdesc Represents a MessageStacksMessage.
     * @implements IMessageStacksMessage
     * @constructor
     * @param {IMessageStacksMessage=} [properties] Properties to set
     */
    function MessageStacksMessage(properties) {
        this.edgeLabelLengths = [];
        this.edgeParents = [];
        this.messageStackIDs = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MessageStacksMessage edgeLabelsPacked.
     * @member {Uint8Array} edgeLabelsPacked
     * @memberof MessageStacksMessage
     * @instance
     */
    MessageStacksMessage.prototype.edgeLabelsPacked = $util.newBuffer([]);

    /**
     * MessageStacksMessage edgeLabelLengths.
     * @member {Array.<number>} edgeLabelLengths
     * @memberof MessageStacksMessage
     * @instance
     */
    MessageStacksMessage.prototype.edgeLabelLengths = $util.emptyArray;

    /**
     * MessageStacksMessage edgeParents.
     * @member {Array.<number>} edgeParents
     * @memberof MessageStacksMessage
     * @instance
     */
    MessageStacksMessage.prototype.edgeParents = $util.emptyArray;

    /**
     * MessageStacksMessage messageStackIDs.
     * @member {Array.<number>} messageStackIDs
     * @memberof MessageStacksMessage
     * @instance
     */
    MessageStacksMessage.prototype.messageStackIDs = $util.emptyArray;

    /**
     * Creates a new MessageStacksMessage instance using the specified properties.
     * @function create
     * @memberof MessageStacksMessage
     * @static
     * @param {IMessageStacksMessage=} [properties] Properties to set
     * @returns {MessageStacksMessage} MessageStacksMessage instance
     */
    MessageStacksMessage.create = function create(properties) {
        return new MessageStacksMessage(properties);
    };

    /**
     * Encodes the specified MessageStacksMessage message. Does not implicitly {@link MessageStacksMessage.verify|verify} messages.
     * @function encode
     * @memberof MessageStacksMessage
     * @static
     * @param {IMessageStacksMessage} message MessageStacksMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MessageStacksMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.edgeLabelsPacked);
        if (message.edgeLabelLengths != null && message.edgeLabelLengths.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (let i = 0; i < message.edgeLabelLengths.length; ++i)
                writer.sint32(message.edgeLabelLengths[i]);
            writer.ldelim();
        }
        if (message.edgeParents != null && message.edgeParents.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.edgeParents.length; ++i)
                writer.uint32(message.edgeParents[i]);
            writer.ldelim();
        }
        if (message.messageStackIDs != null && message.messageStackIDs.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.messageStackIDs.length; ++i)
                writer.uint32(message.messageStackIDs[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified MessageStacksMessage message, length delimited. Does not implicitly {@link MessageStacksMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MessageStacksMessage
     * @static
     * @param {IMessageStacksMessage} message MessageStacksMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MessageStacksMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MessageStacksMessage message from the specified reader or buffer.
     * @function decode
     * @memberof MessageStacksMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MessageStacksMessage} MessageStacksMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MessageStacksMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new MessageStacksMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.edgeLabelsPacked = reader.bytes();
                break;
            case 2:
                if (!(message.edgeLabelLengths && message.edgeLabelLengths.length))
                    message.edgeLabelLengths = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.edgeLabelLengths.push(reader.sint32());
                } else
                    message.edgeLabelLengths.push(reader.sint32());
                break;
            case 3:
                if (!(message.edgeParents && message.edgeParents.length))
                    message.edgeParents = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.edgeParents.push(reader.uint32());
                } else
                    message.edgeParents.push(reader.uint32());
                break;
            case 4:
                if (!(message.messageStackIDs && message.messageStackIDs.length))
                    message.messageStackIDs = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.messageStackIDs.push(reader.uint32());
                } else
                    message.messageStackIDs.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("edgeLabelsPacked"))
            throw $util.ProtocolError("missing required 'edgeLabelsPacked'", { instance: message });
        return message;
    };

    /**
     * Decodes a MessageStacksMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MessageStacksMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MessageStacksMessage} MessageStacksMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MessageStacksMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MessageStacksMessage message.
     * @function verify
     * @memberof MessageStacksMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MessageStacksMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.edgeLabelsPacked && typeof message.edgeLabelsPacked.length === "number" || $util.isString(message.edgeLabelsPacked)))
            return "edgeLabelsPacked: buffer expected";
        if (message.edgeLabelLengths != null && message.hasOwnProperty("edgeLabelLengths")) {
            if (!Array.isArray(message.edgeLabelLengths))
                return "edgeLabelLengths: array expected";
            for (let i = 0; i < message.edgeLabelLengths.length; ++i)
                if (!$util.isInteger(message.edgeLabelLengths[i]))
                    return "edgeLabelLengths: integer[] expected";
        }
        if (message.edgeParents != null && message.hasOwnProperty("edgeParents")) {
            if (!Array.isArray(message.edgeParents))
                return "edgeParents: array expected";
            for (let i = 0; i < message.edgeParents.length; ++i)
                if (!$util.isInteger(message.edgeParents[i]))
                    return "edgeParents: integer[] expected";
        }
        if (message.messageStackIDs != null && message.hasOwnProperty("messageStackIDs")) {
            if (!Array.isArray(message.messageStackIDs))
                return "messageStackIDs: array expected";
            for (let i = 0; i < message.messageStackIDs.length; ++i)
                if (!$util.isInteger(message.messageStackIDs[i]))
                    return "messageStackIDs: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a MessageStacksMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MessageStacksMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MessageStacksMessage} MessageStacksMessage
     */
    MessageStacksMessage.fromObject = function fromObject(object) {
        if (object instanceof MessageStacksMessage)
            return object;
        let message = new MessageStacksMessage();
        if (object.edgeLabelsPacked != null)
            if (typeof object.edgeLabelsPacked === "string")
                $util.base64.decode(object.edgeLabelsPacked, message.edgeLabelsPacked = $util.newBuffer($util.base64.length(object.edgeLabelsPacked)), 0);
            else if (object.edgeLabelsPacked.length)
                message.edgeLabelsPacked = object.edgeLabelsPacked;
        if (object.edgeLabelLengths) {
            if (!Array.isArray(object.edgeLabelLengths))
                throw TypeError(".MessageStacksMessage.edgeLabelLengths: array expected");
            message.edgeLabelLengths = [];
            for (let i = 0; i < object.edgeLabelLengths.length; ++i)
                message.edgeLabelLengths[i] = object.edgeLabelLengths[i] | 0;
        }
        if (object.edgeParents) {
            if (!Array.isArray(object.edgeParents))
                throw TypeError(".MessageStacksMessage.edgeParents: array expected");
            message.edgeParents = [];
            for (let i = 0; i < object.edgeParents.length; ++i)
                message.edgeParents[i] = object.edgeParents[i] >>> 0;
        }
        if (object.messageStackIDs) {
            if (!Array.isArray(object.messageStackIDs))
                throw TypeError(".MessageStacksMessage.messageStackIDs: array expected");
            message.messageStackIDs = [];
            for (let i = 0; i < object.messageStackIDs.length; ++i)
                message.messageStackIDs[i] = object.messageStackIDs[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a MessageStacksMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MessageStacksMessage
     * @static
     * @param {MessageStacksMessage} message MessageStacksMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MessageStacksMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.edgeLabelLengths = [];
            object.edgeParents = [];
            object.messageStackIDs = [];
        }
        if (options.defaults)
            if (options.bytes === String)
                object.edgeLabelsPacked = "";
            else {
                object.edgeLabelsPacked = [];
                if (options.bytes !== Array)
                    object.edgeLabelsPacked = $util.newBuffer(object.edgeLabelsPacked);
            }
        if (message.edgeLabelsPacked != null && message.hasOwnProperty("edgeLabelsPacked"))
            object.edgeLabelsPacked = options.bytes === String ? $util.base64.encode(message.edgeLabelsPacked, 0, message.edgeLabelsPacked.length) : options.bytes === Array ? Array.prototype.slice.call(message.edgeLabelsPacked) : message.edgeLabelsPacked;
        if (message.edgeLabelLengths && message.edgeLabelLengths.length) {
            object.edgeLabelLengths = [];
            for (let j = 0; j < message.edgeLabelLengths.length; ++j)
                object.edgeLabelLengths[j] = message.edgeLabelLengths[j];
        }
        if (message.edgeParents && message.edgeParents.length) {
            object.edgeParents = [];
            for (let j = 0; j < message.edgeParents.length; ++j)
                object.edgeParents[j] = message.edgeParents[j];
        }
        if (message.messageStackIDs && message.messageStackIDs.length) {
            object.messageStackIDs = [];
            for (let j = 0; j < message.messageStackIDs.length; ++j)
                object.messageStackIDs[j] = message.messageStackIDs[j];
        }
        return object;
    };

    /**
     * Converts this MessageStacksMessage to JSON.
     * @function toJSON
     * @memberof MessageStacksMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MessageStacksMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MessageStacksMessage;
})();

export const SavedStateTreeMessage = /*@__PURE__*/ (() => {

    /**
     * Properties of a SavedStateTreeMessage.
     * @exports ISavedStateTreeMessage
     * @interface ISavedStateTreeMessage
     * @property {Uint8Array|null} [self] SavedStateTreeMessage self
     * @property {Array.<string>|null} [childrenKeys] SavedStateTreeMessage childrenKeys
     * @property {Array.<ISavedStateTreeMessage>|null} [childrenValues] SavedStateTreeMessage childrenValues
     */

    /**
     * Constructs a new SavedStateTreeMessage.
     * @exports SavedStateTreeMessage
     * @classdesc Represents a SavedStateTreeMessage.
     * @implements ISavedStateTreeMessage
     * @constructor
     * @param {ISavedStateTreeMessage=} [properties] Properties to set
     */
    function SavedStateTreeMessage(properties) {
        this.childrenKeys = [];
        this.childrenValues = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SavedStateTreeMessage self.
     * @member {Uint8Array} self
     * @memberof SavedStateTreeMessage
     * @instance
     */
    SavedStateTreeMessage.prototype.self = $util.newBuffer([]);

    /**
     * SavedStateTreeMessage childrenKeys.
     * @member {Array.<string>} childrenKeys
     * @memberof SavedStateTreeMessage
     * @instance
     */
    SavedStateTreeMessage.prototype.childrenKeys = $util.emptyArray;

    /**
     * SavedStateTreeMessage childrenValues.
     * @member {Array.<ISavedStateTreeMessage>} childrenValues
     * @memberof SavedStateTreeMessage
     * @instance
     */
    SavedStateTreeMessage.prototype.childrenValues = $util.emptyArray;

    /**
     * Creates a new SavedStateTreeMessage instance using the specified properties.
     * @function create
     * @memberof SavedStateTreeMessage
     * @static
     * @param {ISavedStateTreeMessage=} [properties] Properties to set
     * @returns {SavedStateTreeMessage} SavedStateTreeMessage instance
     */
    SavedStateTreeMessage.create = function create(properties) {
        return new SavedStateTreeMessage(properties);
    };

    /**
     * Encodes the specified SavedStateTreeMessage message. Does not implicitly {@link SavedStateTreeMessage.verify|verify} messages.
     * @function encode
     * @memberof SavedStateTreeMessage
     * @static
     * @param {ISavedStateTreeMessage} message SavedStateTreeMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SavedStateTreeMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.self != null && Object.hasOwnProperty.call(message, "self"))
            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.self);
        if (message.childrenKeys != null && message.childrenKeys.length)
            for (let i = 0; i < message.childrenKeys.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.childrenKeys[i]);
        if (message.childrenValues != null && message.childrenValues.length)
            for (let i = 0; i < message.childrenValues.length; ++i)
                SavedStateTreeMessage.encode(message.childrenValues[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SavedStateTreeMessage message, length delimited. Does not implicitly {@link SavedStateTreeMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SavedStateTreeMessage
     * @static
     * @param {ISavedStateTreeMessage} message SavedStateTreeMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SavedStateTreeMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SavedStateTreeMessage message from the specified reader or buffer.
     * @function decode
     * @memberof SavedStateTreeMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SavedStateTreeMessage} SavedStateTreeMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SavedStateTreeMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new SavedStateTreeMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.self = reader.bytes();
                break;
            case 2:
                if (!(message.childrenKeys && message.childrenKeys.length))
                    message.childrenKeys = [];
                message.childrenKeys.push(reader.string());
                break;
            case 3:
                if (!(message.childrenValues && message.childrenValues.length))
                    message.childrenValues = [];
                message.childrenValues.push(SavedStateTreeMessage.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SavedStateTreeMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SavedStateTreeMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SavedStateTreeMessage} SavedStateTreeMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SavedStateTreeMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SavedStateTreeMessage message.
     * @function verify
     * @memberof SavedStateTreeMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SavedStateTreeMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.self != null && message.hasOwnProperty("self"))
            if (!(message.self && typeof message.self.length === "number" || $util.isString(message.self)))
                return "self: buffer expected";
        if (message.childrenKeys != null && message.hasOwnProperty("childrenKeys")) {
            if (!Array.isArray(message.childrenKeys))
                return "childrenKeys: array expected";
            for (let i = 0; i < message.childrenKeys.length; ++i)
                if (!$util.isString(message.childrenKeys[i]))
                    return "childrenKeys: string[] expected";
        }
        if (message.childrenValues != null && message.hasOwnProperty("childrenValues")) {
            if (!Array.isArray(message.childrenValues))
                return "childrenValues: array expected";
            for (let i = 0; i < message.childrenValues.length; ++i) {
                let error = SavedStateTreeMessage.verify(message.childrenValues[i]);
                if (error)
                    return "childrenValues." + error;
            }
        }
        return null;
    };

    /**
     * Creates a SavedStateTreeMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SavedStateTreeMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SavedStateTreeMessage} SavedStateTreeMessage
     */
    SavedStateTreeMessage.fromObject = function fromObject(object) {
        if (object instanceof SavedStateTreeMessage)
            return object;
        let message = new SavedStateTreeMessage();
        if (object.self != null)
            if (typeof object.self === "string")
                $util.base64.decode(object.self, message.self = $util.newBuffer($util.base64.length(object.self)), 0);
            else if (object.self.length)
                message.self = object.self;
        if (object.childrenKeys) {
            if (!Array.isArray(object.childrenKeys))
                throw TypeError(".SavedStateTreeMessage.childrenKeys: array expected");
            message.childrenKeys = [];
            for (let i = 0; i < object.childrenKeys.length; ++i)
                message.childrenKeys[i] = String(object.childrenKeys[i]);
        }
        if (object.childrenValues) {
            if (!Array.isArray(object.childrenValues))
                throw TypeError(".SavedStateTreeMessage.childrenValues: array expected");
            message.childrenValues = [];
            for (let i = 0; i < object.childrenValues.length; ++i) {
                if (typeof object.childrenValues[i] !== "object")
                    throw TypeError(".SavedStateTreeMessage.childrenValues: object expected");
                message.childrenValues[i] = SavedStateTreeMessage.fromObject(object.childrenValues[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a SavedStateTreeMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SavedStateTreeMessage
     * @static
     * @param {SavedStateTreeMessage} message SavedStateTreeMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SavedStateTreeMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.childrenKeys = [];
            object.childrenValues = [];
        }
        if (options.defaults)
            if (options.bytes === String)
                object.self = "";
            else {
                object.self = [];
                if (options.bytes !== Array)
                    object.self = $util.newBuffer(object.self);
            }
        if (message.self != null && message.hasOwnProperty("self"))
            object.self = options.bytes === String ? $util.base64.encode(message.self, 0, message.self.length) : options.bytes === Array ? Array.prototype.slice.call(message.self) : message.self;
        if (message.childrenKeys && message.childrenKeys.length) {
            object.childrenKeys = [];
            for (let j = 0; j < message.childrenKeys.length; ++j)
                object.childrenKeys[j] = message.childrenKeys[j];
        }
        if (message.childrenValues && message.childrenValues.length) {
            object.childrenValues = [];
            for (let j = 0; j < message.childrenValues.length; ++j)
                object.childrenValues[j] = SavedStateTreeMessage.toObject(message.childrenValues[j], options);
        }
        return object;
    };

    /**
     * Converts this SavedStateTreeMessage to JSON.
     * @function toJSON
     * @memberof SavedStateTreeMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SavedStateTreeMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SavedStateTreeMessage;
})();

export { $root as default };
